import {ErrorHandler} from '@angular/core';
import {logError} from '../../methods/error';

export class GlobalErrorHandler implements ErrorHandler {
  handleError(error) {
    logError(error);
  }
}
